module.exports = __webpack_public_path__ + "static/platform-76808272d6178ae79e814d74a1656e11.png";